const BYTES_COUNT = 1024;
const BYTES_TEXTS = ['Кб', 'Мб', 'Гб'];

export const fileSizeFormatter = (size: number): string => {
  if (Math.abs(size) < BYTES_COUNT) {
    return size + ' б';
  }

  let bytes = size;
  let u = -1;
  const r = 10;

  do {
    bytes /= BYTES_COUNT;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= BYTES_COUNT && u < BYTES_TEXTS.length - 1);

  return bytes.toFixed(2).toString().replace('.00', '').replace('.', ',') + ' ' + BYTES_TEXTS[u];
};
